import PanelTablas from "./pages/tablas_clim_aero/PanelTablasV2.jsx";
import PortalAutoSerivicioAero from "./pages/portal_auto_servicio_aero/portalAutoServicioAero.jsx";
import { HashRouter as Router, Routes, Route } from "react-router-dom";


export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PortalAutoSerivicioAero />} />
        <Route path="/portal-auto-servicio-aero" element={<PortalAutoSerivicioAero />} />
        <Route path="/tca" element={<PanelTablas />} />
      </Routes>
    </Router>
  );
}

